import { render } from "./PatientPage.vue?vue&type=template&id=2e633b34&scoped=true"
import script from "./PatientPage.vue?vue&type=script&lang=js"
export * from "./PatientPage.vue?vue&type=script&lang=js"

import "./PatientPage.vue?vue&type=style&index=0&id=2e633b34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e633b34"],['__file',"src/components/PatientPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e633b34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e633b34', __exports__)) {
    api.reload('2e633b34', __exports__)
  }
  
  module.hot.accept("./PatientPage.vue?vue&type=template&id=2e633b34&scoped=true", () => {
    api.rerender('2e633b34', render)
  })

}


export default __exports__